// Vendor imports
const Immutable = require('immutable')
// Client lib imports
const globalPageContext = require('client/lib/business-events/page-context')
// Common Client V2 imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')
// Sibling imports
const LocationRecord = require('./location')

class PageHistoryRecord extends Immutable.Record({
  location: null,
  pageContext: null,
  title: String()
}) {
  static fromCurrentState() {
    const { pathname, search, hash } = window.location
    return this.newState({
      location: { pathname, search, hash },
      pageContext: globalPageContext.getPageContext(),
      title: document.title
    })
  }

  static newState(state) {
    return Immutable.fromJS(state, reviver)
  }

  isCurrentState() {
    return this.equals(PageHistoryRecord.fromCurrentState())
  }

  applyPageContext() {
    if (this.pageContext) {
      globalPageContext.setPageContext(this.pageContext.toJS())
    }
  }

  revertPageContext() {
    if (this.pageContext) {
      globalPageContext.revertPageContext(this.pageContext.toJS())
    }
  }

  applyTitle() {
    document.title = this.title
  }

  pushState() {
    history.pushState(null, '', this.location.href)
    this.applyTitle()
    this.applyPageContext()
  }

  replaceState() {
    history.replaceState(null, '', this.location.href)
    this.applyTitle()
    this.applyPageContext()
  }
}

const reviver = keyedReviver(PageHistoryRecord, {
  location: LocationRecord.reviver,
  pageContext: defaultReviver
})

module.exports = Object.assign(PageHistoryRecord, {
  reviver
})
